import React, { Component } from 'react'
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import Grid from '@material-ui/core/Grid';
import LabeldValue from './LabeldValue';
import Typography from '@material-ui/core/Typography';
import FormControlLabel from '@material-ui/core/FormControlLabel'
import Checkbox from '@material-ui/core/Checkbox'
import Button from '@material-ui/core/Button'
import { withRouter } from 'react-router-dom'
import Divider from './Divider';
import CircularProgress from '@material-ui/core/CircularProgress';
import RmaLogic from '../Logic/Logic.ts'
import { calculateReturnLabelCost } from '../Logic/calculateReturnLabelCost'
import ErrorBoundary from './ErrorBoundary'
//import Divider from '@material-ui/core/Divider'
class Summary extends Component {
    constructor(props) {
        super(props);

        this.state = {
            shipRates: [],
            summary: {
                details: []
            },
            orderInfo: {
                canRefundOriginalOutBound: false,
                canIncludeReturnLabelCost: false
            },
            setDialogState: props.setDialogState,
            logic: new RmaLogic(),
            isLoading: false,
        }


    }

    state = {
        shipRates: [],
        summary: {
            details: []
        },
        orderInfo: {
            canRefundOriginalOutBound: false,
            canIncludeReturnLabelCost: false
        }
    }

    componentDidMount = async () => {
        let orderInfo = JSON.parse(localStorage.getItem('orderInfo') || '')
        this.setState({ orderInfo: orderInfo })
        await this.buildSummary(orderInfo)
        window.scrollTo(0, 0)
    }

    showLoading = (msg) => {
        this.props.setDialogState(
            true,
            msg,
            <CircularProgress />,
            <></>,
            false,
            false)
    }

    hideLoad = () => {
        this.props.setDialogState(
            false,
            '',
            <></>,
            <></>,
            false,
            false)
    }

    buildSummary = async (orderInfo) => {
        this.showLoading('Calculating Summary')

        let summary = {
            details: [],
            labelCost: 0,
            refundAmount: 0,
            hasExchange: false,
            refundOriginalOutboundShipping: orderInfo.refundOriginalOutboundShipping,
            freeReturnLabel: orderInfo.doNotDeductLabelCost,
            skipShipping: orderInfo.useOwnLabel ,
            isInternational: orderInfo.isInternational,
            originalOutboundShippingAmount: orderInfo.originalOutboundShippingAmount,
            actualTotalWeight: 0,
            totalWeight: 0,
            mailingCost: 0,
            //  isTest:true
        };
        let validLines = orderInfo.lines.filter(f => f.hasEdits && f.isValid && (f.isExchange || f.isReturn))

        summary.actualTotalWeight = this.getTotalWeight(validLines);
        if (summary.actualTotalWeight === 0) {
            summary.actualTotalWeight = 1;
        }
        summary.totalWeight = Math.ceil(summary.actualTotalWeight + (summary.actualTotalWeight * .15));


        for (var i = 0; i < validLines.length; i++) {
            let ol = validLines[i];

            if (ol.isExchange) {
                summary.hasExchange = true;
                summary.details.push({
                    type: "Returning",
                    sku: ol.sku,
                    amount: ol.price * -1,
                    quantity: ol.quantity * -1,
                    name: ol.productTitle,
                    weight: ol.weight,
                    fulfilProductId: ol.productId,
                    comments: ol.comments,
                    reasonId: ol.reasonId < 0 ? ol.subReasonId : ol.reasonId,
                    reason: ol.reason,
                    channel_identifier: ol.lineChannelIdentifier,
                    newShopifyVariantId: ol.newShopifyVariantId,
                    originalOrderId: orderInfo.originOrderId,
                    originalOrderLineId: ol.originLineId,
                    isExchange: ol.isExchange,
                    isReturn: ol.isReturn
                });


                const rpr = await fetch(`/apps/rma/LoadProductReplacementInfo?variant=${ol.newVariantId}`);
                const ffProduct = await rpr.json()
                summary.details.push({
                    type: "Receiving",
                    sku: ffProduct.code,
                    amount: ol.price,
                    quantity: ol.quantity,
                    name: ffProduct.name,
                    weight: ol.weight,
                    fulfilProductId: ffProduct.id,
                    channel_identifier: ol.lineChannelIdentifier,
                    originalOrderId: ol.orderId,
                    originalOrderLineId: ol.lineId,
                    isExchange: ol.isExchange,
                    isReturn: ol.isReturn
                });
            }

            if (ol.isReturn) {
                summary.details.push({
                    type: "Returning",
                    sku: ol.sku,
                    amount: ol.price * -1,
                    quantity: ol.quantity * -1,
                    name: ol.productTitle,
                    weight: ol.weight,
                    fulfilProductId: ol.productId,
                    comments: ol.comments,
                    reasonId: ol.reasonId < 0 ? ol.subReasonId : ol.reasonId,
                    reason: ol.reason,
                    channel_identifier: ol.lineChannelIdentifier,
                    originalOrderId: ol.orderId,
                    originalOrderLineId: ol.lineId,
                    isExchange: ol.isExchange,
                    isReturn: ol.isReturn
                });
            }
        }
        summary.originalOrderId = orderInfo.rootOriginOrderId;
        summary.reference = orderInfo.reference;
        summary.labelCost = 0;
        if (!orderInfo.isInternational && !summary.hasExchange) {
            const result = await this.loadShippingRates(orderInfo.zip, '50613', summary.totalWeight, this.userIp);
            const returnLabelCost = calculateReturnLabelCost(result?.postagePrice, {
                skipShipping: summary.skipShipping,
                hasExchange: summary.hasExchange,
                freeReturnLabel: summary.freeReturnLabel
            });
            summary.labelCost = returnLabelCost.labelCost;
            summary.actualCost = returnLabelCost.actualCost;
            summary.mailClass = returnLabelCost.mailClass;
        }
        summary.details.forEach(f => summary.refundAmount += Number(f.amount));

        summary.refundAmount *= -1;
        summary.taxRefund = this.calcTaxRefund(summary.refundAmount, orderInfo.untaxedAmount, orderInfo.taxAmount);


        if (orderInfo.mailToCustomer) {
            summary.mailingCost = 2
            summary.details.push(
                {
                    type: "Shipping",
                    sku: "Mail Shipping Label Fee",
                    amount: 2,
                    quantity: 1,
                    name: "Shipping",
                    fulfilProductId: 1,
                    weight: 0
                })
        }
        if (summary.refundOriginalOutboundShipping) {
            summary.refundAmount += orderInfo.originalOutboundShippingAmount
            summary.details.push(
                {
                    type: "Shipping",
                    sku: "Shipping Refund",
                    amount: orderInfo.originalOutboundShippingAmount * -1,
                    quantity: 1,
                    name: "Shipping",
                    fulfilProductId: 1,
                    weight: 0
                })
        }

        if (summary.hasExchange === false && summary.skipShipping === false && !summary.freeReturnLabel && !summary.isInternational) {
            summary.details.push(
                {
                    type: "Shipping",
                    sku: "[Shipping] Shipping",
                    amount: summary.labelCost,
                    quantity: 1,
                    name: "Shipping",
                    fulfilProductId: 1,
                    weight: 0
                })
        }
        summary.total = Number(summary.refundAmount) - Number(summary.labelCost) - Number(summary.mailingCost) + Number(summary.taxRefund)

        this.setState({ summary: summary })

        orderInfo.summary = summary
        localStorage.setItem('orderInfo', JSON.stringify(orderInfo))

        this.hideLoad()
    }



    loadShippingRates = async (fromPostal, toPostal, weight) => {
        let retVal = {}
        const postData = {
            fromPostal: fromPostal,
            postal: toPostal,
            weight: weight
        };
        var currentShipRates = this.state.shipRates
        var cachedVersion = currentShipRates.find(f => f.postData.fromPostal === fromPostal && f.postData.postal === toPostal && f.postData.weight === weight)
        if (cachedVersion) {
            retVal = cachedVersion.postData.results
        } else {

            var ratesRes = await fetch('/apps/rma/Func/V2/RMA/LoadUspsShippingRates', {
                method: 'POST',
                headers: {
                    Accept: 'application/json',
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify(postData)
            });
            retVal = await ratesRes.json();
            postData.results = retVal
            currentShipRates.push({
                postData
            })
            this.setState({ shipRates: currentShipRates })
        }
        return retVal;
    }

    getTotalWeight = (lines) => {
        var weight = 0;
        for (let index = 0; index < lines.length; index++) {
            const element = lines[index];
            weight += element.weight;
        }
        return weight;
    };

    calcTaxRefund = (refundAmount, originalUntaxedAmount, originalTaxAmount) => {
        let r = Number(Number(refundAmount) / Number(originalUntaxedAmount) * Number(originalTaxAmount));
        if (isNaN(r)) {
            r = 0;
        }
        return r;
    }


    handleCheckChange = name => async event => {
        let order = this.state.orderInfo
        order[name] = event.target.checked
        this.setState({ orderInfo: order })

        await this.buildSummary(this.state.orderInfo)

    };

    // persist = (newState) => {
    //     let orderInfo = JSON.parse(localStorage.getItem('orderInfo') || '')
    //     let indx = orderInfo.lines.findIndex(f => f.uiid === this.state.line.uiid)
    //     orderInfo.lines[indx] = this.state.line
    //     localStorage.setItem('orderInfo', JSON.stringify(orderInfo))
    // }

    nextButtonClick = async () => {
        console.log("With debounce");
        if(this.state.isLoading){
            return;    
        }
        this.setState({ isLoading: true});
        
        this.showLoading('Building your return order.')
        try {
            var retVal = await this.state.logic.PostToFunc('BuildReturnOrder', this.state.summary)
            localStorage.setItem('buildReturnResult', JSON.stringify(retVal))
            this.hideLoad();
            this.props.history.replace('/pages/returns/results')
        } catch (error) {
            this.hideLoad();
            var oi = this.state.orderInfo
            oi.errorTitle = "Encountered problem(s) while building your return order."
            oi.errorMessage = "Encountered problem(s) while building your return order."
            localStorage.setItem('errorOrderInfo', JSON.stringify(oi))
            this.props.history.replace('/pages/returns/whoops')
        }
        this.setState({ isLoading: false})
    }

    backButtonClick = () => {
        this.props.history.replace('/pages/returns/status')
    }

    render() {
        const orderInfo = this.state.orderInfo
        const summary = this.state.summary
        const rows = summary.details
        const cellStyle = {
            maxHeight: 30
            , padding: 3
            , paddingRight: 10
            , margin: 0
        }

        // const HorizontalDivide = (<div style={{border:'1px solid black'}}>-</div>)


        return (
            <ErrorBoundary>
                <Grid container direction="column" justify="flex-start" alignItems="flex-start"  >
                    <Typography variant="h6" display="block" component="div" >
                        Return / Exchange Summary</Typography>
                    <Table  >
                        <TableHead style={{ background: "#f0f0f0" }}>
                            <TableRow >
                                <TableCell style={cellStyle}>Quantity</TableCell>
                                <TableCell style={cellStyle} align="left">Item Details</TableCell>

                            </TableRow>
                        </TableHead >
                        <TableBody>
                            {rows.map((v, i) => (
                                <TableRow key={i}>
                                    <TableCell style={cellStyle} component="th" scope="row">
                                        {v.quantity}
                                    </TableCell>
                                    <TableCell style={cellStyle} align="left">
                                        <Grid container direction="column" justify="flex-start" alignItems="center"  >
                                            <LabeldValue title={v.name} value=" " />
                                            <LabeldValue title='SKU: ' value={v.sku} />
                                            <LabeldValue title='Amount: ' prefix='$' value={Number(v.amount).toFixed(2)} color={v.amount < 0 ? 'red' : ''} />
                                        </Grid>
                                    </TableCell>

                                </TableRow>
                            ))}
                        </TableBody>
                    </Table>

                    <Grid container direction="row" justify="flex-end" alignItems="center" style={{ marginTop: 10 }}>
                        <Grid item>
                            {/* <LabeldValue title='Product Refund: ' prefix='$' value={Number(summary.productRefund).toFixed(2)} color={summary.productRefund < 0 ? 'red' : ''} /> */}
                            <LabeldValue title='Taxes Refund: ' prefix='$' value={Number(summary.taxRefund).toFixed(2)} color={summary.taxRefund < 0 ? 'red' : ''} />
                            <LabeldValue title='Shipping Label: ' prefix='$' value={Number(summary.labelCost).toFixed(2)} color={summary.labelCost < 0 ? 'red' : ''} />
                            {summary.originalOutboundShippingAmount > 0 && summary.refundOriginalOutboundShipping ?
                                <LabeldValue title='Shipping Refund: ' prefix='$' value={Number(summary.originalOutboundShippingAmount).toFixed(2)} color={summary.originalOutboundShippingAmount < 0? 'red' : ''} />
                                : <></>}
                            <LabeldValue title='Mail Label: ' prefix='$' value={Number(summary.mailingCost).toFixed(2)} color={summary.mailingCost < 0 ? 'red' : ''} />
                            <LabeldValue title='Total: ' prefix='$' value={Number(summary.total).toFixed(2)} color={summary.refundAmount < 0 ? 'red' : ''} />
                        </Grid>
                    </Grid>
                    <Divider />
                    <Grid container direction="row" justify="center" alignItems="center"  >
                        <Grid item>
                            <Typography align="center" variant="subtitle2" display="block" component="div" >
                                {`$${summary?.total?.toFixed(2)} will be refunded to your original payment method 1-3 business days after we receive your return. `}</Typography>
                            <Typography align="center" variant="subtitle2" display="block" component="div" >
                                {`On the next screen you can print the shipping label and return instructions, or provide an email address and they will be emailed to you.`}</Typography>
                        </Grid>
                    </Grid>

                    {
                        summary.isInternational && (
                            <>
                                <Divider />
                                <Grid container direction="row" justify="flex-start" alignItems="center"  >
                                    <Grid item>
                                        <div>Thank you for being a valued customer. While we do accept returns for a refund on eligible items, please note that <b>international customers are responsible for covering the return shipping costs</b> to BraceAbility. You can view our full <a target="_blank" rel="noopener noreferrer" href="https://www.braceability.com/pages/returns#international-return-policy"> return policy here.</a></div>
                                    </Grid>
                                </Grid>
                            </>
                        )
                    }
                    <Divider />

                    {summary.isInternational === false ?
                        <FormControlLabel
                            style={{ marginBottom: 15, textTransform: "none" }}
                            control={
                                <Checkbox

                                    onChange={this.handleCheckChange('useOwnLabel')}
                                    value={orderInfo.useOwnLabel}
                                    color="primary"
                                />
                            }
                            label="I do not want you to provide me a label or deduct the cost from my refund. I will pay the return shipping charges directly to the carrier of my choice."
                        /> : <></>}


                    {this.state.orderInfo.useOwnLabel || summary.isInternational ?
                        <div style={{ fontWeight: '600' }}>
                            <div style={{ textDecoration: 'underline' }}>Please send your return to:</div>
                            <div >Attn: BraceAbility Returns</div>
                            <div >6122 Nordic Drive</div>
                            <div >Cedar Falls, IA 50613</div>
                        </div>
                        :
                        <></>
                    }


                    {/* {summary.isInternational === false ?
                        summary.hasExchange ?
                            <FormControlLabel
                                style={{ marginBottom: 15, textTransform: "none" }}
                                control={
                                    <Checkbox

                                        disabled={orderInfo.useOwnLabel}
                                        onChange={this.handleCheckChange('mailToCustomerFree')}
                                        value={orderInfo.mailToCustomerFree}
                                        color="primary"
                                    />
                                }
                                label="I do not have access to a printer. Please mail a printed label to my original order Shipping Address."

                            />
                            :
                            <FormControlLabel
                                style={{ marginBottom: 15, textTransform: "none" }}
                                control={
                                    <Checkbox

                                        disabled={orderInfo.useOwnLabel}
                                        onChange={this.handleCheckChange('mailToCustomer')}
                                        value={orderInfo.mailToCustomer}
                                        color="primary"
                                    />
                                }
                                label="I do not have access to a printer. Please deduct an additional $2.00 from my refund and mail a printed label to my original order Shipping Address."
                            />
                        : <></>} */}

                    {orderInfo.canRefundOriginalOutBound ? <FormControlLabel
                        control={
                            <Checkbox

                                onChange={this.handleCheckChange('refundOriginalOutboundShipping')}
                                value={orderInfo.refundOriginalOutboundShipping}
                                color="primary"
                            />
                        }
                        label="Refund original outbound shipping"
                        style={{ fontStyle: "italic", color: "darkgray", marginBottom: 15 }}
                    /> : <></>}

                    {orderInfo.canExcludeReturnLabelCost ? <FormControlLabel
                        control={
                            <Checkbox
                                disabled={orderInfo.useOwnLabel}
                                onChange={this.handleCheckChange('doNotDeductLabelCost')}
                                value={orderInfo.doNotDeductLabelCost}
                                color="primary"
                            />
                        }
                        label="Do not deduct the cost of the return label"
                        style={{ fontStyle: "italic", color: "darkgray", marginBottom: 15 }}
                    /> : <></>}
                    <Divider />
                    <Grid container direction="row" justify="flex-start" alignItems="center" spacing={1}  >
                        <Grid item>
                            <Button variant="outlined" color="primary" onClick={this.backButtonClick}>Back</Button>
                        </Grid>
                        <Grid item>
                            <Button variant="contained" color="primary" onClick={this.nextButtonClick} >Next</Button>
                        </Grid>
                    </Grid>

                </Grid>
            </ErrorBoundary>
        );
    }
}

export default withRouter(Summary)

